// src/pages/Dashboard.js (Versão Corrigida)

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from '../components/common/Spinner/Spinner';
import { useToast } from '../hooks/useToast';

const Dashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { addToast } = useToast();

  useEffect(() => {
    // A lógica de espera pelo currentUser continua a mesma
    if (currentUser && currentUser.perfil) {

      switch (currentUser.perfil) {
        case 'ADM MASTER':
          // Redirecionamento para o ADM MASTER (já estava correto)
          navigate('/admin/dashboard', { replace: true });
          break;
        case 'ADM.ORG':
          // Redirecionamento para o ADM.ORG (já estava correto)
          navigate('/adm-org/painel', { replace: true });
          break;
        case 'ARTICULADOR':
          navigate('/articulador/dashboard', { replace: true });
          break;
        case 'ALTA GESTAO':
          navigate('/gestao/priorizacao-colegiada', { replace: true });
          break;
        default:
          // Caso de um perfil desconhecido, envia para a página de login
          addToast('Perfil desconhecido.', 'error');
          navigate('/login', { replace: true });
          break;
      }
    }
    // Se o loading do AuthContext ainda não terminou, ou se o usuário é nulo,
    // o spinner continuará sendo exibido, o que está correto.

  // addToast e estavel e entraria em laco se listado.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, navigate]);

  // Exibe um spinner enquanto o useEffect decide para onde navegar
  return <Spinner text="A carregar perfil e redirecionar..." fullScreen />;

};

export default Dashboard;